import { Component, OnDestroy, OnInit } from '@angular/core';

import { BasePageComponent } from '../../../base-page';
import { Category } from '../../../../models/Category';
import { CategoryService } from '../../../../services/category.service';
import { ConfirmComponent } from '../../DialogBoxes/confirm/confirm.component';
import { DialogBoxCategoriesComponent } from '../../DialogBoxes/dialog-box-categories/dialog-box-categories.component';
import { HttpService } from '../../../../services/http/http.service';
import { IAppState } from '../../../../interfaces/app-state';
import { MatDialog } from '@angular/material';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';
import { first } from 'rxjs/internal/operators/first';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent extends BasePageComponent implements OnInit, OnDestroy {
  bordered = true;
  position = 'bottom';
  searchValue = '';
  pageSize = 10;
  listOfDisplayData: Category[] = [];
  listOfAllData: Category[] = [];
  list: Category[] = [];
  currentPage = 0;
  sortName: string | null = null;
  sortValue: string | null = null;
  constructor(store: Store<IAppState>,
    httpSv: HttpService, private categoryService: CategoryService,
    public dialog: MatDialog, private toastr: ToastrService) {
    super(store, httpSv);
    this.getData(`${environment.apiUrl}/Category/`, 'tableData', 'setLoaded');
    this.categoryService.getAll().pipe(first()).subscribe(categories => {
      this.listOfAllData = categories;
      this.list = categories;
    }
    );
  }
  currentPageDataChange($event: Category[]): void {
    this.listOfDisplayData = $event;
  }
  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;
    this.listOfAllData = this.list;
    this.listOfDisplayData = this.list;
    this.search();
  }
  reset(): void {
    this.searchValue = '';
    this.listOfAllData = this.list;
    this.search();
  }
  select(event) {

    var path = event.path || (event.composedPath && event.composedPath());

    if (path[1].className.match('active')) {
      path[1].classList.remove('active');
    }
    else {
      path[1].classList.add('active');
    }
  }
  search(): void {
    const filterFunc = (item: Category) => {
      return (
        item['name'].toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
      );
    };
    const data = this.list.filter((item: Category) => filterFunc(item));
    this.listOfAllData = data.sort((a, b) =>

      this.sortValue === 'ascend'
        ? a[this.sortName!] > b[this.sortName!]
          ? 1
          : -1
        : b[this.sortName!] > a[this.sortName!]
          ? 1
          : -1
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  removeSelectedRows() {
    let row: any = {};
    row.text = 'Confirma a remoção da(s) categoria(s) selecionada(s)?'
    let dialogRef = this.dialog.open(ConfirmComponent, {
      id: 'confirm',
      data: row
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) { }
      else if (result.event == 'sim') {
        const e = document.querySelectorAll('tr');
        e.forEach(el => {

          if (el.className.match('active')) {
            const index: number = this.listOfAllData.findIndex(d => d['name'].trim() === el.children[0].lastChild.nodeValue.trim());
            this.categoryService.deleteCategory(this.listOfAllData[index]['categoryId']).subscribe((data) => {
              this.categoryService.getAll().subscribe(x => {
                this.listOfAllData = x;
              });
              this.toastr.success('Categoria(s) removida(s) com sucesso!');
            },
              err => {
                this.toastr.error('Algo ocorreu mal!');
              }
            );
          }
        });
      }
    });
  }
  openDialog(action, e, i) {
    if (e == null || !e.target.className.match('ant-table-column-sorters') && !e.target.className.match('ant-spin-container')) {

      var path = e == null ? '' : e.path || (e.composedPath && e.composedPath());

      let row: any = {};
      row.action = action;
      row.id = e == null ? '' : this.listOfAllData[(this.currentPage * this.pageSize + i)]['categoryId'];
      row.name = e == null ? '' : path[1].children[0].innerText;
      const dialogRef = this.dialog.open(DialogBoxCategoriesComponent, {
        width: '99%',
        maxWidth: '850px',
        height: 'auto',
        data: row,
        disableClose: true,
        closeOnNavigation: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === undefined) { }
        else if (result.event == 'Adicionar') {
          this.addRowData(result.data);
        } else if (result.event == 'Modificar') {
          this.updateRowData(result.data);
        }
      });
    }
  }


  addRowData(rowObj) {
    this.categoryService.createCategory(rowObj.name, rowObj.productId).subscribe((data) => {
      this.categoryService.getAll().subscribe(x => {
        this.listOfAllData = x;
      });
    });
  }
  updateRowData(rowObj) {
    this.categoryService.updateCategory(rowObj.id, rowObj.name, rowObj.productId).subscribe((data) => {
      this.categoryService.getAll().subscribe(x => {
        this.listOfAllData = x;
      });
    });
  }
  ngOnInit() {
    super.ngOnInit();
  }
  custom(i) {
    this.currentPage = i - 1;
  }
}
